import React, { FC } from 'react'
import { styled } from '@linaria/react'
import { ButtonRegular } from '../ui/Button'
import Close from '../svgr/Close'
import { colors } from '../styles/colors'

export const DialogCloseButton: FC<{
  onClick: () => void
}> = ({ onClick }) => {
  return (
    <CloseButton onClick={onClick}>
      <Close />
    </CloseButton>
  )
}

const CloseButton = styled(ButtonRegular)`
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${colors.textSecondary};
    }
  }
`
